import { ref, watch } from "vue";

const STORAGE_KEY = "diskola-theme";

const media =
  typeof window !== "undefined" ? window.matchMedia("(prefers-color-scheme: dark)") : null;

function storedTheme() {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    return value === "light" || value === "dark" ? value : null;
  } catch {
    return null;
  }
}

const theme = ref(storedTheme() || (media && media.matches ? "dark" : "light"));

// Ikuti perubahan tema OS hanya selama user belum memilih eksplisit
if (media) {
  media.addEventListener("change", (e) => {
    if (!storedTheme()) {
      theme.value = e.matches ? "dark" : "light";
    }
  });
}

watch(
  theme,
  (value) => {
    document.documentElement.dataset.theme = value;
  },
  { immediate: true }
);

export function useTheme() {
  function toggleTheme() {
    theme.value = theme.value === "dark" ? "light" : "dark";
    try {
      localStorage.setItem(STORAGE_KEY, theme.value);
    } catch {
      // localStorage tidak tersedia (private mode) — tema tetap berlaku untuk sesi ini
    }
  }

  return { theme, toggleTheme };
}
